import * as Models from "../Models";
import * as Services from "../Services";
import * as Routes from "../Routes";
import * as Shared from "../Shared";
import * as _ from 'lodash'
import * as toastr from "toastr";
import { Account } from "../Models/Customer";

export interface IInvoicesDirectiveScope extends ng.IScope {
  invoicesDirective: InvoicesDirective;
    igsCustomerNumber: string;
    doNotContact: string;
}

export class InvoicesDirective implements ng.IDirective {
  public restrict = "E";
  public scope = {
      igsCustomerNumber: "@",
      doNotContact: "@"
  };

  public template = require("./invoices-directive.html");

  public $scope: IInvoicesDirectiveScope;
  public $state: angular.ui.IStateService;

  public igsCustomerNumber: string;
  public doNotContact: string;
  public prefersPaperInvoices: boolean;
  public invoices: Models.Customer.InvoiceDetailBaseResponse.InvoiceDetailBaseResponse[];
  public sortProperty: string;
  public inverted: boolean;
  public foundSuccessfulInvoice: boolean;
  public invoiceToResend: Models.Customer.ResendInvoiceRequest.ResendInvoiceEmail;
  public resendInvoiceRequest: Models.Customer.ResendInvoiceRequest.ResendInvoiceRequest;
  public solarAccountBalanceResponse: Models.Customer.SolarAccountBalanceResponse.ISolarAccountBalanceResponse;
  public productType: string;

  public static $inject = [
    "$state",
    "InvoiceApiClient",
    "CustomerApiClient",
      "$modal"
  ];
  constructor(
    $state: angular.ui.IStateService,
    private invoiceApiClient: Services.InvoiceApiClient.IInvoiceApiClient,
    private customerApiClient: Services.CustomerApiClient.ICustomerApiClient,
      public $modal: angular.ui.bootstrap.IModalService
  ) {
    this.$state = $state;
  }

  public link = ($scope: IInvoicesDirectiveScope): void => {
    $scope.invoicesDirective = this;
    this.$scope = $scope;
    this.foundSuccessfulInvoice = false;

    this.$scope.$watch("igsCustomerNumber", () => {
        this.igsCustomerNumber = $scope.igsCustomerNumber;
        this.doNotContact = $scope.doNotContact;
      this.setup();
      this.setAccountDetails();
    });
    this.resendInvoiceRequest = new Models.Customer.ResendInvoiceRequest.ResendInvoiceRequest();
  };

    public viewInvoice = (invoice: Models.Customer.InvoiceDetailBaseResponse.InvoiceDetailBaseResponse) => {
        if (invoice.documentKey != null) {
            this.invoiceApiClient.previewPdfInvoice(invoice.documentKey, 'false')
                .then((response: any) => {
                    var documentData = 'data:application/pdf;base64,' + response.substring(0, response.length);
                    var invoiceDisplay = '<html><body><div><iframe  src="' + documentData + '" width="100%" height="1000px" /></div></body></html>';
                    this.$modal.open({
                        template: invoiceDisplay,
                        size: "lg"
                    });
                });
        } else {
            this.invoiceApiClient.previewInvoice(invoice.invoiceNumber)
                .then((response: any) => {
                    this.$modal.open({
                        templateUrl: response.substring(0, response.length),
                        size: "lg"
                    });
                });
        }
  };

  public setup = (): void => {
    this.customerApiClient
      .getCurentSolarAccountBalance(
        new Models.Customer.SolarAccountBalanceRequest.SolarAccountBalanceRequest(
          this.igsCustomerNumber
        )
      )
      .then(
        (
          result: Models.Customer.SolarAccountBalanceResponse.SolarAccountBalanceResponse
        ) => {
          this.solarAccountBalanceResponse = result;
        }
      )
      .then((_) => this.loadInvoices());
  };

  public loadInvoices = (): void => {
    this.invoiceApiClient.getSolarInvoiceListForCustomer(this.igsCustomerNumber)
      .then((result: any) => {
        this.invoices = result;
        this.setBilledStatusForInvoices();
      });
  };

  public setAccountDetails = (): void => {
    this.customerApiClient.getAccount(this.igsCustomerNumber)
      .then((acct: Models.Customer.Account.Account) => {this.prefersPaperInvoices = acct.paperInvoice})
  }

  public setBilledStatusForInvoices = (): void => {
    _.forEach(this.invoices, invoice => {
      if (this.foundSuccessfulInvoice) {
        invoice.billingSuccessful = true;
      } else if (
        invoice.pastDue <= 0 ||
        this.solarAccountBalanceResponse.accountBalance <= 0 ||
        invoice.billingSuccessful
      ) {
        if (this.solarAccountBalanceResponse.accountBalance <= 0) {
          invoice.billingSuccessful = true;
        }
        this.foundSuccessfulInvoice = true;
        }
        if (!this.productType) {
            if (invoice.rate !== 'multiple') {
                var rate = +invoice.rate;
                this.productType = rate > 1 ? 'LEASE' : 'PPA';
            }
        }
        
    });
  };

  public openResendModal = (
    invoice: Models.Customer.InvoiceDetailResponse.InvoiceDetailResponse
  ) => {
      if (this.doNotContact === 'true') {
          toastr.error('Customer is listed as Do Not Contact. No communication to customer is permitted', 'Customer Not To Be Contacted');
      } else {
          var modalInstance = this.$modal.open({
              template: require("../Routes/Customer/Misc/resendInvoiceModal.html"),
              controller:
                  Shared.Framework.ControllerHelpers.create(Routes.Customer.Misc.resendInvoiceModal.ResendInvoiceModalCtrl),
              resolve: {
                  passedInInvoice: () => {
                      return invoice;
                  },
                  passedInEmail: () => {
                      this.invoiceToResend = new Models.Customer.ResendInvoiceRequest.ResendInvoiceEmail();
                      this.invoiceToResend.emailAddress = invoice.emailAddress;
                      this.invoiceToResend.emailAddressId = 1;

                      this.resendInvoiceRequest.emailAddresses = new Array<
                          Models.Customer.ResendInvoiceRequest.ResendInvoiceEmail
                      >();
                      this.resendInvoiceRequest.emailAddresses.push(this.invoiceToResend);

                      return this.resendInvoiceRequest;
                  },
                  passedInPrefersPaperInvoices: () => {
                    return this.prefersPaperInvoices;
                  }
              }
          });
      }
  };

  public sortBy = (sortproperty: string): void => {
    if (sortproperty === "generation") {
      this.sortProperty = "generation";
      this.inverted = !this.inverted;
      if (this.inverted) {
        this.invoices.sort((a, b) => a.generationCharge - b.generationCharge);
      } else {
        this.invoices.sort((a, b) => b.generationCharge - a.generationCharge);
      }
    } else if (sortproperty === "balance") {
      this.sortProperty = "balance";
      this.inverted = !this.inverted;
      if (this.inverted) {
        this.invoices.sort((a, b) => a.balanceDue - b.balanceDue);
      } else {
        this.invoices.sort((a, b) => b.balanceDue - a.balanceDue);
      }
    } else if (sortproperty === "rate") {
      this.sortProperty = "rate";
      this.inverted = !this.inverted;
      if (this.inverted) {
        //this.invoices.sort((a, b) => a.rate - b.rate); todo fix sort
      } else {
        //this.invoices.sort((a, b) => b.rate - a.rate); todo fix
      }
    } else if (sortproperty === "production") {
      this.sortProperty = "production";
      this.inverted = !this.inverted;
      if (this.inverted) {
        this.invoices.sort((a, b) => a.usageAmount - b.usageAmount);
      } else {
        this.invoices.sort((a, b) => b.usageAmount - a.usageAmount);
      }
    } else if (sortproperty === "sentDate") {
      this.sortProperty = "sentDate";
      this.inverted = !this.inverted;
      if (this.inverted) {
        this.invoices.sort(
          (a, b) =>
            new Date(a.approvalDate).getTime() -
            new Date(b.usageAmount).getTime()
        );
      } else {
        this.invoices.sort(
          (a, b) =>
            new Date(b.approvalDate).getTime() -
            new Date(a.usageAmount).getTime()
        );
      }
    } else if (sortproperty === "dueDate") {
      this.sortProperty = "dueDate";
      this.inverted = !this.inverted;
      if (this.inverted) {
        this.invoices.sort(
          (a, b) =>
            new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime()
        );
      } else {
        this.invoices.sort(
          (a, b) =>
            new Date(b.dueDate).getTime() - new Date(a.dueDate).getTime()
        );
      }
    } else if (sortproperty === "status") {
      this.sortProperty = "status";
      this.inverted = !this.inverted;
      if (this.inverted) {
        this.invoices.sort(function(a, b) {
          if (a.billingSuccessful === b.billingSuccessful) {
            return 0;
          } else if (a.billingSuccessful) {
            return -1;
          } else {
            return 1;
          }
        });
      } else {
        this.invoices.sort(function(a, b) {
          if (a.billingSuccessful === b.billingSuccessful) {
            return 0;
          } else if (a.billingSuccessful) {
            return 1;
          } else {
            return -1;
          }
        });
      }
    }
  };
}
